import {inject} from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, Router, RouterStateSnapshot } from '@angular/router';
import { navigationUrlForNewApplication } from '../service/navigation-urls';
import {getUser} from '@portal-workspace/grow-ui-library';
import {CUSTOMERS_ACCESS_LEVEL} from '@portal-workspace/grow-shared-library';

export const customerAccessGuard  = (): CanActivateFn => {
  return (
    route: ActivatedRouteSnapshot, state: RouterStateSnapshot
  ) => {
    const router = inject(Router);
    const user = getUser()
    if (user?.priviledges.some(priviledge => CUSTOMERS_ACCESS_LEVEL.includes(priviledge))) {
        return true;
    }
    return router.navigate(navigationUrlForNewApplication())
  }
}

